import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TipoDocumento } from '../model/TipoDocumento.enum';

@Injectable({
  providedIn: 'root'
})
export class InvioSegnalazioniService {
  constructor(private http: HttpClient) { }

  public postIdInvio() {
    return this.http
      .post<number>(`${environment.urls.base}/segnalazione/conferma-invio-segnalazioni`,
      {
        observe: 'response'
      });
  }

  public downloadSegnalazioniDaInviare(idInvio: Number, idEvento: Number, tipoDocumento: TipoDocumento): Observable<HttpResponse<Blob>> {
    return this.http
      .get(`${environment.urls.base}/segnalazione/download-segnalazioni/${idInvio}/${idEvento}/${tipoDocumento}`, { responseType: 'blob', observe: 'response' });
  }

  public inviaSegnalazioni(idInvio: Number, idEvento: Number) {
    return this.http
    .post(
      `${environment.urls.base}/segnalazione/invia-segnalazioni/${idInvio}/${idEvento}`,
      {
        observe: 'response'
      }
    );
  }

}